import BaseService from "./BaseService"
import api_acesso from "@/config/api_acesso"

export default class FormsService extends BaseService {
  static index (params) {
    const endpoint = api_acesso.url + `/forms`
    const config = {
      headers: this.getHeaders(`Bearer ${localStorage.access_token}`),
      params
    }

    return this.getData(endpoint, config)
  }

  static show (id) {
    const endpoint = api_acesso.url + `/forms/${id}`
    const config = {
      headers: this.getHeaders(`Bearer ${localStorage.access_token}`)
    }

    return this.getData(endpoint, config)
  }

  static store (form) {
    const endpoint = api_acesso.url + `/forms`
    const config = {
      headers: this.getHeaders(`Bearer ${localStorage.access_token}`)
    }

    form.tenant = config.headers['x-tenant-id']
    return this.sendData(endpoint, form, config)
  }
}
